module.exports = __webpack_public_path__ + "static/media/blik_website.21d93a3b.webp";